import {request} from "../request/request";

const education = {
  getMyOne: () => request.read('/education', null, true),
  getOne: (userId) => request.read(`/education/${userId}`, null, true),
  putFile: (data) => request.update(`/education/file`, data, true),
};

export {education};